import { Component, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { INT_WFSTATUS_TYPE_ACTIONS, WFSTATUS_TYPE_ACTIONS } from "app/shared/actions/actions.constants";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { WorkflowService } from 'app/services/workflow.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { statusdto } from 'app/models/statusdto';
import { AuthWebService } from 'app/services/authweb.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wfstatus',
  templateUrl: './wfstatus.component.html',
  styleUrls: ['./wfstatus.component.scss']
})
export class WFStatusComponent implements OnInit {
  statusdto: statusdto = new statusdto;
  statuses: any = [];
  selectedData: any = null;
  selectedStatusData: any = null;
  isLoading: boolean = false;
  lblHeading = "Manage Workflow Status";
  user: any = {};
  mode:any = 'Add';

  wfStatusTypeActions = INT_WFSTATUS_TYPE_ACTIONS;

  constructor(private service: WorkflowService, private toaster: ToastNotificationService, 
    private authWebService: AuthWebService, private datePipe: DatePipe,
    public utility: UtilityServiceService, private dialog: ConfirmDialogService) { }

  ngOnInit(): void {
    this.user = this.authWebService.userData.User
    this.getStatuses();
  }

  //#region General
  onChecked(event, item){
    if (event.target.checked) {
      this.selectedStatusData = item;
    } else {
      this.selectedStatusData = null;
    }
  }

  doPermitAction(event: any) {
    const button = document.getElementById("popupButton") as HTMLButtonElement;
    if (event.value == WFSTATUS_TYPE_ACTIONS.AddWFStatus) {
      this.lblHeading = "Add Status";
      this.mode = 'Add';
      this.statusdto = new statusdto;
      button.click();
    } else if (event.value == WFSTATUS_TYPE_ACTIONS.DeleteWFStatus) {
      if(this.selectedStatusData == null){
         this.toaster.error("Please select the record first!","Delete")
       }else{
        this.statusdto = this.selectedStatusData;
         this.onDelete();
       }
    } else if (event.value == WFSTATUS_TYPE_ACTIONS.EditWFStatus) {
      this.lblHeading = "Edit Status";
      this.mode = 'Edit';
      if(this.selectedStatusData == null){
        this.toaster.error("Please select the record first!","Edit")
      }else{
        this.statusdto = this.selectedStatusData;
        button.click();
      }
    }
  }
  //#endregion

  //#region CRUD
  getStatuses(){
    this.isLoading = true;
    this.service.getWorkflowStatus().subscribe(
      (result) => {
        this.statuses = result;
        this.isLoading = false;
      },
      (error) => {
        this.toaster.error(
          "Failed to load statuses. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );

  }

  onAdd(){

    if(this.statuses.find(x=>x.status==this.statusdto.status)){
      this.toaster.error("Status already exists!","Status");
      return;
    }

    if(this.statuses.find(x=>x.code==this.statusdto.code)){
      this.toaster.error("Code already exists!","Status");
      return;
    }

    this.statusdto.usercreated = this.user.Id;
    this.statusdto.datecreated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.statusdto.userupdated = this.user.Id;
    this.statusdto.dateupdated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.statusdto.deletedyn = false;

    this.isLoading = true;
    this.service.addWorkflowStatus(this.statusdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Status successfully added","Status");
        this.getStatuses();
      },
      (error) => {
        this.toaster.error(
          "Failed to save status. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );
  }

  onUpdate(){

    if(this.statuses.find(x=>x.status==this.statusdto.status && x.statusesid != this.statusdto.statusesid)){
      this.toaster.error("Status already exists!","Status");
      return;
    }

    if(this.statuses.find(x=>x.code==this.statusdto.code && x.statusesid != this.statusdto.statusesid)){
      this.toaster.error("Code already exists!","Status");
      return;
    }

    this.isLoading = true;
    this.service.updateWorkflowStatus(this.statusdto.statusesid, this.statusdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Status successfully updated","Status");
        this.getStatuses();
      },
      (error) => {
        this.toaster.error(
          "Failed to update status. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );
  }

  onDelete(){
    this.dialog.confirmThis(`Are you sure you want to delete this status.`,
    () => {
      this.isLoading = true;      
      this.service.deleteWorkflowStatus(this.statusdto.statusesid).subscribe(
        (result) => {
          this.toaster.success("Status successfully deleted","Status");
          this.getStatuses();
        },
        (error) => {
          this.toaster.error(
            "Failed to update status. Please try again",
            "Workflow Status"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      this.isLoading = false;
      return;
    }
  );

  }
  //#endregion
}
